/**
 * Pill / status pill. DESIGN.md §Chips, pills and tags: 12px/700, 1px 8px, full pill;
 * neutral is Blue Mist on light and the accent tint on dark; status tones tint the 600
 * step at ~12 percent on light (10 is the nearest opacity step) and the 300 step at
 * ~14 percent on dark (15), with the status ink as text. Reference: stars.css `.pill`.
 */
import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "./cn";

const badge = cva(
  "tw-inline-flex tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded-pill tw-px-2 tw-py-px tw-text-xs tw-font-bold",
  {
    variants: {
      tone: {
        neutral:
          "tw-bg-surface-selected tw-text-text dark:tw-bg-accent-tint dark:tw-text-text-accent",
        accent: "tw-bg-accent-tint tw-text-text-accent",
        success:
          "tw-bg-overlay-success-600/10 tw-text-success dark:tw-bg-overlay-success-300/15",
        warning:
          "tw-bg-overlay-warning-600/10 tw-text-warning dark:tw-bg-overlay-warning-300/15",
        danger:
          "tw-bg-overlay-danger-600/10 tw-text-danger dark:tw-bg-overlay-danger-300/15",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export function Badge({ tone = "neutral", className, ...props }) {
  return (
    <span
      data-tone={tone}
      className={cn(badge({ tone }), className)}
      {...props}
    />
  );
}
